export default {
  'intl': 'https://www.linkedin.com/company/nuinalp',
  'pt-br': 'https://www.linkedin.com/company/nuinalp'
} as const;